"use client";

import { Children, FC, cloneElement, isValidElement, useEffect, useState } from "react";

import "./accordion.css";
import { AccordionItemProps, AccordionProps } from "./types";

const Accordion: FC<AccordionProps> = ({ tag = "div", children, classes }) => {
  const [expandedCard, setExpandedCard] = useState<string | number | null>(null);
  const Tag = tag;

  const setOpen = (i: string | number | null) => {
    setExpandedCard(i);
  };

  const isOpen = (i: string | number) => {
    return expandedCard === i;
  };

  const onChildSelect = (i: string | number) => {
    setOpen(isOpen(i) ? null : i);
  };

  useEffect(() => {
    let defaultOpen: string | number | null = null;

    Children.forEach(children, (c, i) => {
      if (!!c) {
        if (isValidElement<AccordionItemProps>(c)) {
          if ((c.props as any).isInitialOpen) {
            defaultOpen = c.key || i;
          }
        } else {
          console.warn("Element is not an accordion item.", c);
        }
      }
    });

    if (defaultOpen !== null) {
      setOpen(defaultOpen);
    }
  }, [children]);

  return (
    <Tag className={`accordion ${classes ? classes : ""}`}>
      {Children.map(children, (child, i) => {
        if (isValidElement<AccordionItemProps>(child)) {
          return cloneElement(child, {
            onSelect: () => onChildSelect(child.key || i),
            expanded: child.props.expanded || isOpen(child.key || i),
          });
        }
        return null;
      })}
    </Tag>
  );
};

export default Accordion;
